module.exports = __webpack_public_path__ + "img/Axpo_80X30.90b2d189.png";